import { createFileRoute } from "@tanstack/react-router"
import { Blocks } from "lucide-react"

export const Route = createFileRoute("/_app/integrations")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 text-center p-8">
      <div className="w-12 h-12 rounded-2xl bg-muted flex items-center justify-center">
        <Blocks className="w-6 h-6 text-muted-foreground" />
      </div>
      <div className="flex flex-col gap-1">
        <h2 className="text-lg font-semibold">Integrations coming soon</h2>
        <p className="text-sm text-muted-foreground max-w-xs">
          Connect your favorite tools to automatically capture knowledge into your Mind Palace.
        </p>
      </div>
    </div>
  )
}
